//DEPENDENCIES
import React from 'react';
import HTMLReactParser from 'html-react-parser';

// GLOBAL HELPERS
import { getListData } from 'helpers/getListData';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { INTERFACE, SETTINGS, SPOT_INSTRUCTIONS } from 'pathnames.js';

// GLOBAL FUNCITONS
import { makePath } from 'functions';

// PARTS
import Main from 'parts/main/Main';
import Table, { Filters } from 'parts/table/Table';
import Title from 'parts/title/Title';

// LOCAL VARIABLES
import { ACTIONS } from 'columns';

// MAIN COMPONENT
const AutomatedSpotInstructions = () => {
  // RETURN
  return (
    <Main>
      <Title documentTitle="Automated Spot Instructions" title="Automated Spot Instructions" />
      <Filters>
        <Filters.Search name="spotInstructionTitle" placeholder="Search by title" />
      </Filters>
      <Table sortable={false} mobilePreviewKeys={['automated_spot_instruction_title', 'is_active']} />
    </Main>
  );
};

// COLUMN COMPONENTS
const ViewLink = ({ value }) => HTMLReactParser(value || '');

// EXPORT
export default getListData(AutomatedSpotInstructions, {
  key: 'automatedSpotInstructions',
  path: makePath(INTERFACE.settings, SETTINGS.spotInstructions, SPOT_INSTRUCTIONS.automated),
  fetchArgs: {
    endpoint: makePath(ENDPOINTS.admin.spotInstructions.auto.list)
  },
  columns: [
    {
      key: 'automated_spot_instruction_title',
      label: 'Title',
      component: ViewLink,
      width: 175
    },
    {
      key: 'triggered_by',
      label: 'Tiggered By',
      width: 175
    },
    {
      component: Table.Boolean,
      key: 'upload_document_required',
      label: 'Upload Doc Required',
      className: 'text-center',
      width: 120
    }
  ],
  actions: [ACTIONS.edit('automated_spot_instruction_id')]
});
